// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

// TODO: Replace the following with your app's Firebase project configuration
// You can find this in the Firebase Console -> Project Settings -> General -> Your Apps
const firebaseConfig = {
  apiKey: "AIzaSyDTYRD5dIKKZwbjKN-KsPmmhzjy0fYnmjM",
  authDomain: "winrox11.firebaseapp.com",
  projectId: "winrox11",
  storageBucket: "winrox11.firebasestorage.app",
  messagingSenderId: "661741368051",
  appId: "1:661741368051:web:3a771ff604a86920267d86",
  measurementId: "G-PZSFSZCWJN"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
